import React, { useState, useMemo, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Row, Col, Card, CardBody, Table, Badge } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagination from "components/Common/Pagination"

// assets
import "../../../../assets/css/Sales/Sales.css"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import NewPagination from "components/Common/Newpagination"
import "../../../../assets/css/Freelancer/Freelancer.css"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const navigate = useNavigate()

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  useEffect(()=> {
    setPageSize(50)
  },[])
  // Render the UI for your table
  return (
    <div>
      <Row className="mb-4 justify-content-between align-items-center">
        <Col md={4} className="d-flex align-items-start pe-0">
          {/* counts */}
          <div className="d-flex justify-content-between w-100 text-center">
            <a
              href="#"
              className="text-primary pt-2 px-2 rounded payment-count"
            >
              <h4>2</h4>
              <h4>Total</h4>
            </a>
            <a
              href="#"
              className="text-success pt-2 px-2 rounded payment-count"
            >
              <h4>0</h4>
              <h4>Paid</h4>
            </a>
            <a href="#" className="text-danger pt-2 px-2 rounded payment-count">
              <h4>3</h4>
              <h4>Unpaid</h4>
            </a>
          </div>
        </Col>
        <Col md={8} className="d-flex justify-content-end align-items-center">
          <select
            className="border-radius form-select  mb-3"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <div className="ml-10">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline ">
              <div className="position-relative mt-2">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* <Table
        className="table table-bordered payment-table"
        {...getTableProps()}
      >
        <thead className={`${fixedHeader ? "fix-header" : ""} fixed_view_payment_table`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th key={index} {...column.getHeaderProps()}>
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td key={index} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table> */}
       <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedHeader && page.length >= 5 ? "fixed_view_payment_table" : ""
            }`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      >
                        <i
                          title="info"
                          className="bx bx-info-circle ms-1 info-icon"
                        ></i>
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
      <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const ViewPayment = ({ introducer_payment }) => {
  const [fixButtons, setFixButtons] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "created_at",
        isInfoIcon: true,
        className: "view_created_at text-center",
        style : {width : "6%"},
        Cell: cellProps => {
          return (
            <div className="text-center">
              {moment(cellProps.row.original.created_at).format("DD-MM-YYYY")}
            </div>
          )
        },
      },
      {
        Header: "Project",
        accessor: "projectname",
        isInfoIcon: true,
        className : "view_projectname" 
      },
      {
        Header: "Invoice",
        accessor: "invoice",
        isInfoIcon: true,
        className : "view_invoice text-center"
      },
      {
        Header: "Amount",
        accessor: "cost",
        isInfoIcon: true,
        className : "view_amount text-center"
      },
      {
        Header: "TDS",
        accessor: "tds",
        isInfoIcon: true,
        className : "view_tds text-center"
      },
      {
        Header: "Status",
        accessor: "status",
        isInfoIcon: true,
        className : "view_status text-center",
        Cell: cellProps => {
          const {status} = cellProps.row.original;
          const badgeClass = status == "paid" ? "bg-success custom_badge" : "bg-danger custom_badge";

          return (
            <Badge className={badgeClass}>
              {status}
            </Badge>
          )
        },
      },
    ],
    []
  )
  const data = [
    {
      created_at :"09/10/2024",
      projectname : "Eath BMS",
      invoice : "INV/2023-2024/0001",
      cost : "1200",
      tds : "90",
      status : "paid"
    },
    {
      created_at :"09/10/2024",
      projectname : "Eath BMS",
      invoice : "INV/2023-2024/0001",
      cost : "1200",
      tds : "90",
      status : "unpaid"
    },
    {
      created_at :"09/10/2024",
      projectname : "Eath BMS",
      invoice : "INV/2023-2024/0001",
      cost : "1200",
      tds : "90",
      status : "paid"
    },
    {
      created_at :"09/10/2024",
      projectname : "Eath BMS",
      invoice : "INV/2023-2024/0001",
      cost : "1200",
      tds : "90",
      status : "unpaid"
    },

  ]
  return (
    <React.Fragment>
      <div>
        <div>
          {/* Fixed Buttons */}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewPayment
